export default {
  "container": "_container_1fg2t_1",
  "title": "_title_1fg2t_14",
  "header": "_header_1fg2t_27",
  "edit": "_edit_1fg2t_30",
  "dialogHeader": "_dialogHeader_1fg2t_34",
  "dialog": "_dialog_1fg2t_34"
};import "ni:sha-256;BG8Gu35MfHDZV_8DZUfp5MfgEOKQAVTKhmJ4TTdt5XE";